import { render, staticRenderFns } from "./MyIssues.vue?vue&type=template&id=a27756be&"
import script from "./MyIssues.vue?vue&type=script&lang=js&"
export * from "./MyIssues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports